export const GENDER_MALE = 1;
export const GENDER_FEMALE = 2;

export const genderOptions = [
	{
		value: GENDER_MALE,
		name: 'muž',
	},
	{
		value: GENDER_FEMALE,
		name: 'žena',
	},
];
